// Should match WebhookPayloadSchemas from API.
export enum OrderPayloadSchema {
  Default = 'default',
  ShedSuite = 'shed-suite',
}
